import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtistPage from "../pages/artist/page";
import OccaPage from "../pages/artist/occa/page";
import IronPage from "../pages/artist/iron/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artist/diskonnected",
    element: <ArtistPage />,
  },
  {
    path: "/artist/occa",
    element: <OccaPage />,
  },
  {
    path: "/artist/iron",
    element: <IronPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
